import { darken, getLuminance, lighten } from 'polished'

import BrenntagSansBoldWoff from './fonts/brenntag-sans/BrenntagSans-Bold.woff'
import BrenntagSansBoldWoff2 from './fonts/brenntag-sans/BrenntagSans-Bold.woff2'
import BrenntagSansRegularWoff from './fonts/brenntag-sans/BrenntagSans-Regular.woff'
import BrenntagSansRegularWoff2 from './fonts/brenntag-sans/BrenntagSans-Regular.woff2'

export const FontImportStyle = `
  @font-face {
    font-family: system;
    font-style: normal;
    font-weight: 300;
    src: local('.SFNSText-Light'), local('.HelveticaNeueDeskInterface-Light'),
      local('.LucidaGrandeUI'), local('Ubuntu Light'), local('Segoe UI Light'),
      local('Roboto-Light'), local('DroidSans'), local('Tahoma');
  }

  @font-face {
    font-family: 'BrenntagSans Bold';
    src: url(${BrenntagSansBoldWoff}) format('woff'),
      url(${BrenntagSansBoldWoff2}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: 'BrenntagSans Regular';
    src: url(${BrenntagSansRegularWoff}) format('woff2'),
      url(${BrenntagSansRegularWoff2}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
  }
`

export const FontImportUrl =
  'https://fonts.googleapis.com/css?family=Work+Sans:300,400,500,800,900&display=swap'

export const contrastColor = (amount: number, color: string, cutOff = 0.7) =>
  getLuminance(color) > cutOff ? darken(amount, color) : lighten(amount, color)
